import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import api from "@/api/axios";
import ProjectDashboard from "./ProjectDashboard";

export default function ProjectsLayout({ children }) {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const isCreatePage = location.pathname === "/projects/create";

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await api.get("/api/projects");
        setProjects(res.data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  
  useEffect(() => {
    if (!id || projects.length === 0) return;

    const exists = projects.some((p) => p._id === id);
    if (!exists) {
      navigate("/projects", { replace: true });
    }
  }, [id, projects, navigate]);

  
  if (isCreatePage) return children;

  return (
  <div className="h-full w-full overflow-y-auto">
  
    {children ? (
      children
    ) : loading ? (
      <div className="text-gray-600">Loading project...</div>
    ) : id ? (
      <ProjectDashboard key={id} />
    ) : (
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">Projects</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p) => (
            <div
              key={p._id}
              onClick={() => navigate(`/projects/${p._id}`)}
              className="cursor-pointer bg-white border rounded-xl p-5 hover:shadow-sm transition"
            >
              <h3 className="font-semibold text-gray-900">{p.name}</h3>
              <p className="text-sm text-gray-500 mt-1">
                Click to open project
              </p>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate("/projects/create")}
          className="mt-6 px-5 py-2 rounded-lg bg-[#3F00FF] text-white hover:bg-[#3200cc]"
        >
          + Create New Project
        </button>
      </div>
    )}
  </div>
);

}
